/*
Poornima 09/19/2022 2701250447 Fixed GAL-127,132,73,60,104 bugs
Sai Krishna 11/07/2022 3031450488 Added all fields in run and additional fields step and prepopulated dynamic fields in 5th step
Sai Krishna 11/08/2022 3031450488 Fixed prepopulation bugs in dynamic fields and added multiselect component for client type
Gummala Prakash 11/08/2022 3031450488 Added classes and fixed alignments for textfields.
Sai Krishna 11/08/2022 3031450488 Fixed prepopulation bugs in dynamic fields
saikrishna 11/09/2022 3031450488 Added dropdown API for phase and fixed date UI bugs
Prakash Gummala 11/10-/2022  3031450488 Fixed TextFields Alignments.
SaiKrishna 11/23/2022 3225736869 Improper data reset issue fixed.
SaiKrishna 11/24/2022 2699217591 Added validations to dynamic fields
Ashraf 11/24/2022 3031450488 passing props to dynamic fields
Suresh Peddavoora 11/25/2022 2699217591 Fixed Multiselect Dropdown Alignment Issues.
Sohel 11/28/2022  3031450488 Fixed Date Issue
Poornima 11/29/2022  2699217591 Date validation changes
Dilip 11/30/2022 2699217591 added required validation for filter method fields
rajesh 12/01/2022 2699217591 added validation required
Sohel 12/05/2022 2699217591 changed phase placeholder
Suresh Peddavoora 12/05/2022 2699217591 Fixed Validation Alignments for Date fields.
Dilip 12/05/2022  2699217591 Removed unecesarry console.log statements
Ashraf 12/26/2022 2699217591 fixed on touch date validation issue
Ashraf 01/02/2023 2699217591 fixed page break issue
Ashraf 01/03/2023 2700271704 renamed disposition to status
Ashraf 01/06/2022 2700271704 fixed action greater than(>) date value
kavyareddy 01/17/2023 2700271704 Fixed dropdown closing issue in status,phase ,collectors
Suresh Peddavoora 02/09/2023 2700271704 Added Classname for Textfield Enhancements
Prakash 02/14/2023 2700271704 Implemented New UI Changes for Autocomplete Component.
Sohel 02/16/2023 2701234204 Fixed Validation Issue
Prakash 02/16/2023 2700271704 Fixed Autocomplete dropdown alignments issue.
Prakash 02/17/2023 2700271704 Added class for Multiselect Label Component.
Prakash 02/20/2023 2700271704 Added class for Multiselect Label Component.
Sohel 01/03/2023 2700271704 Access Method condition changes
Raghu 03/01/2023 2700271704 fixed alignmnets
Raghu 03/06/2023 2700271704 added new classname for date picker
Suresh Peddavoora 03/23/2023 2700271704 Fixed Alignments for helper text
Ravi 03/25/2023 2700271704 Added GuiAutoComplete textField
Guru Prasad 03/27/2023 2700271704 Added alignments for textField
Ravi 04/30/2023 2700271704 fixed fieldName prepopulate issue
Ravi 03/31/2023 2700271704 fixed value reset issue conditionally
suresh peddavoora 04/06/2023 2700271704 fields alignments fixes
Sohel 04/05/2022 2692790263 FIxed Filter Method Validation issue
Sohel 05/24/2023 2692790263 Added Required Validation
Akhila 05/30/2023 2692790263 bug fixed unsaved changes popUp
Sohel 07/06/2023 2692790263 FIxed Page Break Issue
Sohel 06/08/2023 3075234474 Added Between and Not Between condition For Account By status
Sohel 06/08/2023 3075234474 Access Methods Changes
Sohel 06/09/2023 3075154998 Added between and not Between in Filter Methods
Suresh peddavoora 06/09/2023 3075154998 fixed textfield alignments
Sohel 06/09/2023 3075154998 Values Field Changes
Prakash 12/06/2023 3075154998 fixed field for runareport
Sohel 06/14/2023 3075154998 Fixed Field Reset Issue
Akhila 06/16/2023 3075154998 Added Total and T conditonally in sql output for date field type
Akhila 06/19/2023 3075154998 filter method field by list date changes field TODAY or T
Sohel 06/20/2023 3075154998 Fixed Filter Methods Reset Issue
Sohel 06/20/2023 2692790263 Fixed WorkQueue Code data Issue
Sohel 06/20/2023 2692790263 Fixed Filter Method Reset Issue
Sohel 06/21/2023 2692790263 Fixed DATE Field Prepopulate issue
Sohel 06/22/2023 2692790263 Fixed Report Rest Issue
Ravi 07/07/2023 2692790263 Fixed respository field Prepopulate issue
*/
import {
  Button,
  Checkbox,
  FormControl,
  IconButton,
  TextField,
  FormHelperText,
} from '@material-ui/core';
import React, {useContext, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {DISPOSITION_CODE, PHASE} from '../../../../constants/Lookup';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {
  fetchUserDefinedFields,
  fetchUserDefinedWindows,
  handleSearchRuleGroupFieldData,
} from '../../../../redux/reducers/EventTactics/EventTactics';
import Clear from '@material-ui/icons/Clear';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';

const GetAccessMethodFields = ({
  accessMethodFields,
  values,
  setFieldValue,
  setShowRuleGroupSearch,
  reportDialogData,
  fieldCodeValue,
  additionalInfoData,
  renderedFrom,
  formProps,
  fieldSubmitted,
  setSubmitted,
  addTask,
  isActionChanged,
  handleDirty,
  resetPromptDataRef,
  module,
}) => {
  const {touched, errors, dirty, handleBlur} = formProps;
  const check = JSON.stringify(touched) === '{}' ? false : dirty;
  useEffect(() => {
    if (check) {
      handleDirty && handleDirty(check);
    }
  }, [check]);
  const [getData, setGetData] = useState([]);
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {userDefinedWindowData, userDefinedFieldsData} = useSelector(
    ({addEventTactic}) => addEventTactic,
  );
  const [repoFieldData, setRepoFieldData] = useState('');
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.fieldName === option || item === option ) {
          setRepoFieldData(item);
          label = item;
        }
      });
    return label;
  };
  const {dropDownData, clientCodeData, collectorsData} = useSelector(
    ({addReportMaster}) => addReportMaster,
  );
  useEffect(() => {
    dispatch(fetchUserDefinedWindows());
  }, []);

  useEffect(() => {
    if (additionalInfoData?.accessMethod === 'DBUDWFIELDS' && !isActionChanged?.current ) {
      setFieldValue(
        'fieldsName',
        additionalInfoData?.fieldName ? getObject(additionalInfoData?.fieldName, getData) : '',
      );
    }
    // else {
    //   setFieldValue("fieldsName", "");
    // }
  }, [additionalInfoData, getData]);
  useEffect(() => {
    if (additionalInfoData?.accessMethod === 'DBUDWFIELDS' && !isActionChanged?.current) {
      setFieldValue(
        'repoitoryName',
        additionalInfoData?.repositoryName ?
          userDefinedWindowData?.filter((el) => {
            return el?.repositoryName == additionalInfoData?.repositoryName;
          })?.[0] :
          '',
      );
    }
  }, [additionalInfoData, repoFieldData]);
  useEffect(() => {
    if (userDefinedFieldsData) {
      setGetData(userDefinedFieldsData);
    }
  }, [userDefinedFieldsData, getData]);

  useEffect(() => {
    if (additionalInfoData?.accessMethod === 'DBUDWFIELDS' && !isActionChanged?.current) {
      dispatch(fetchUserDefinedFields(additionalInfoData?.repositoryName));
    }
  }, [additionalInfoData?.accessMethod]);
  const getIsBetween = () => {
    if (
      values?.action ?
        values?.action?.toLowerCase() === 'between' :
        additionalInfoData?.action?.toLowerCase() === 'between'
    ) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    dispatch(fetchUserDefinedWindows());
  }, []);
  useEffect(() => {
    if (
      accessMethodFields?.length >= 1 &&
      additionalInfoData &&
     ( !resetPromptDataRef?.current &&
      !isActionChanged?.current)
    ) {
      additionalInfoData?.startDate &&
        setFieldValue(
          'startDate',
          // additionalInfoData?.startDate ? new Date(additionalInfoData?.startDate) : ""
          additionalInfoData?.startDate ?
            additionalInfoData?.startDate?.replace('cast(now()as date)', 'TODAY') :
            '',
        );
      // additionalInfoData?.endDate && setFieldValue("lastDate", additionalInfoData?.endDate ? new Date(additionalInfoData?.endDate) : "")
      switch (additionalInfoData?.accessMethod || additionalInfoData?.accessType) {
      case 'DBCOLLECTOR':
        setFieldValue('collectors', additionalInfoData?.value ? additionalInfoData?.value : []);
        break;
      case 'DBUDWFIELDS':
        // setFieldValue(
        //   "repoitoryName",
        //   additionalInfoData?.repositoryName ? additionalInfoData?.repositoryName : ""
        // );
        // if (
        //   values?.action === additionalInfoData?.action &&
        //   values?.repoitoryName === additionalInfoData?.repositoryName &&
        //   values?.fieldsName?.fieldName === additionalInfoData?.fieldName
        // ) {
        setFieldValue(
          'values',
          additionalInfoData?.value ?
            additionalInfoData?.value?.map((i) => i?.replace('cast(now()as date)', 'TODAY')) :
            [],
        );
        setFieldValue(
          'toValues',
          additionalInfoData?.toValue ?
            additionalInfoData?.toValue?.replace('cast(now()as date)', 'TODAY') :
            '',
        );
        setFieldValue(
          'fromValues',
          additionalInfoData?.fromValue ?
            additionalInfoData?.fromValue?.replace('cast(now()as date)', 'TODAY') :
            '',
        );
        // } else {
        //   setFieldValue("values", []);
        //   setFieldValue("toValues", "");
        //   setFieldValue("fromValues", "");
        // }

        break;
      case 'DSDISP':
        // if (values?.action === additionalInfoData?.action) {
        setFieldValue(
          'disposition',
          getOptions(DISPOSITION_CODE).length > 0 ?
            getOptions(DISPOSITION_CODE)?.filter((each) =>
              additionalInfoData?.value?.includes(each?.valueCode),
            ) :
            [],
        );
        // } else {
        //   setFieldValue("disposition", []);
        // }
        break;
      case 'DBCLNT':
        // if (values?.action === additionalInfoData?.action) {
        setFieldValue(
          'client',
          additionalInfoData?.value ?
            clientCodeData?.filter((each) =>
              additionalInfoData?.value?.includes(each?.clientCode),
            ) :
            [],
        );
        // } else {
        //   setFieldValue("client", []);
        // }

        break;
      case 'DSSTAT':
        // if (values?.action === additionalInfoData?.action) {
        setFieldValue(
          'phase',
          getOptions(PHASE).length > 0 ?
            getOptions(PHASE)?.filter((each) =>
              additionalInfoData?.value?.includes(each?.valueCode),
            ) :
            [],
        );
        // } else {
        //   setFieldValue("phase", []);
        // }
        break;
      case 'DBLSTDTE':
        const dateFieldName = ['<', '>']?.includes(additionalInfoData?.action) ?
          'Date' :
          'startDate';
          // if (!addTask && values?.action === additionalInfoData?.action) {
        additionalInfoData?.startDate &&
            setFieldValue(
              dateFieldName,
              // additionalInfoData?.startDate ? new Date(additionalInfoData?.startDate) : ""
              additionalInfoData?.startDate ?
                additionalInfoData?.startDate?.replace('cast(now()as date)', 'TODAY') :
                '',
            );
        additionalInfoData?.endDate &&
            setFieldValue(
              'lastDate',
              // additionalInfoData?.endDate ? new Date(additionalInfoData?.endDate) : ""
              additionalInfoData?.endDate ?
                additionalInfoData?.endDate?.replace('cast(now()as date)', 'TODAY') :
                '',
            );
        // // } else {
        //   setFieldValue("startDate", "");
        //   setFieldValue("lastDate", "");
        //   setFieldValue("Date", "");
        // }
        // if (dateFieldName === "Date" && addTask) {
        //   additionalInfoData?.action === "<" &&
        //     additionalInfoData?.startDate &&
        //     setFieldValue(
        //       dateFieldName,
        //       // additionalInfoData?.startDate ? new Date(additionalInfoData?.startDate) : ""
        //       additionalInfoData?.startDate
        //         ? additionalInfoData?.startDate?.replace("cast(now()as date)", "TODAY")
        //         : ""
        //     );
        //   additionalInfoData?.action === ">" &&
        //     additionalInfoData?.endDate &&
        //     setFieldValue(
        //       dateFieldName,
        //       // additionalInfoData?.endDate ? new Date(additionalInfoData?.endDate) : ""
        //       additionalInfoData?.endDate
        //         ? additionalInfoData?.endDate?.replace("cast(now()as date)", "TODAY")
        //         : ""
        //     );
        //   additionalInfoData?.endDate &&
        //     setFieldValue(
        //       "lastDate",
        //       // additionalInfoData?.endDate ? new Date(additionalInfoData?.endDate) : ""
        //       additionalInfoData?.endDate
        //         ? additionalInfoData?.endDate?.replace("cast(now()as date)", "TODAY")
        //         : ""
        //     );
        // } else if (dateFieldName === "startDate" && addTask) {
        //   additionalInfoData?.startDate &&
        //     setFieldValue(
        //       dateFieldName,
        //       // additionalInfoData?.startDate ? new Date(additionalInfoData?.startDate) : ""
        //       additionalInfoData?.startDate
        //         ? additionalInfoData?.startDate?.replace("cast(now()as date)", "TODAY")
        //         : ""
        //     );
        //   additionalInfoData?.endDate &&
        //     setFieldValue(
        //       "lastDate",
        //       // additionalInfoData?.endDate ? new Date(additionalInfoData?.endDate) : ""
        //       additionalInfoData?.endDate
        //         ? additionalInfoData?.endDate?.replace("cast(now()as date)", "TODAY")
        //         : ""
        //     );
        // }
        break;
      default:
        break;
      }
    } else if ((module === 'scheduler' && isActionChanged?.current) || (module === 'reports' && resetPromptDataRef?.current)) {
      // setFieldValue("repoitoryName", "");
      setFieldValue('values', []);
      setFieldValue('phase', []);
      setFieldValue('startDate', '');
      setFieldValue('lastDate', '');
      setFieldValue('collectors', []);
      setFieldValue('disposition', []);
      setFieldValue('client', []);
      setFieldValue('toValues', '');
      setFieldValue('fromValues', '');
      if (module === 'reports') {
        resetPromptDataRef.current = false;
      }
    }
  }, [additionalInfoData, accessMethodFields, userDefinedFieldsData]);
  const isCurrentFieldDisabled = (currentFieldName) => {
    const fieldNames = accessMethodFields
      .filter((field) => field.paramName !== currentFieldName)
      .map((field) => field.paramName);
    let isFieldDisabled = false;
    fieldNames.forEach((field) => {
      if (values[field]?.length > 0) {
        isFieldDisabled = true;
      }
    });
    return isFieldDisabled;
  };
  const getOptions = (typeCode) => {
    let label = [];

    label = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];

    return label;
  };
  useEffect(() => {
    if (fieldCodeValue && Object.keys(fieldCodeValue)?.length) {
      // setFieldValue("phase",[])
      // setFieldValue("startDate",null)
      // setFieldValue("endDate",null)
      // setFieldValue("collectors",[])
      // setFieldValue("disposition",[])
    }
  }, [fieldCodeValue?.fieldCode]);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const getField = (field, key) => {
    switch (field.paramType) {
    // case "Repository":
    //   return (
    //     <div
    //       key={key}
    //       // className={`col form-group `}
    //       className="col-sm-6 col-md-4 col-lg-4 pl-0 form-group autocomplete-field"
    //     >
    //       <FormControl margin="dense" variant="outlined" fullWidth>
    //         <GuiAutoComplete
    //           classes={{
    //             option: classes.option,
    //           }}
    //           name={field.paramName}
    //           size="small"
    //           onBlur={handleBlur}
    //           value={values[field.paramName] || ""}
    //           onChange={(e, value) => {
    //             setFieldValue(field.paramName, value);
    //             value?.length > 0 ? dispatch(fetchUserDefinedFields(value)) : null;
    //           }}
    //           options={userDefinedWindowData}
    //           renderInput={(params) => (
    //             <div className="select-field">
    //               <GuiTextField
    //                 className={` ${classes.labelName}`}
    //                 {...params}
    //                 variant="outlined"
    //                 margin="dense"
    //                 label={"Repository Name"}
    //                 required
    //                 error={Boolean(fieldSubmitted && errors[field.paramName])}
    //                 placeholder={field.paramLabel}
    //               />
    //             </div>
    //           )}
    //         />
    //       </FormControl>
    //       <FormHelperText style={{ color: "red" }} variant="outlined">
    //         {fieldSubmitted && errors[field.paramName] ? errors[field.paramName] : ""}
    //       </FormHelperText>
    //     </div>
    //   );

    // case "Fields":
    //   return (
    //     <div key={key} className="col-sm-6 col-md-4 col-lg-4 form-group autocomplete-field">
    //       <FormControl margin="dense" variant="outlined" fullWidth>
    //         <GuiAutoComplete
    //           classes={{
    //             option: classes.option,
    //           }}
    //           name={field.paramName}
    //           size="small"
    //           onBlur={handleBlur}
    //           value={values[field.paramName] || ""}
    //           onChange={(e, value) => {
    //             setFieldValue(field.paramName, value);
    //           }}
    //           options={userDefinedFieldsData}
    //           getOptionLabel={(option) => {
    //             return option && option?.fieldName ? option.fieldName : "";
    //           }}
    //           renderInput={(params) => (
    //             <div className="select-field">
    //               <GuiTextField
    //                 className={` ${classes.labelName}`}
    //                 {...params}
    //                 variant="outlined"
    //                 margin="dense"
    //                 required
    //                 error={Boolean(fieldSubmitted && errors[field.paramName])}
    //                 label={"Field Name"}
    //                 placeholder={field.paramLabel}
    //               />
    //             </div>
    //           )}
    //         />
    //       </FormControl>
    //       <FormHelperText style={{ color: "red" }} variant="outlined">
    //         {fieldSubmitted && errors[field.paramName] ? errors[field.paramName] : ""}
    //       </FormHelperText>
    //     </div>
    //   );
    case 'Values':
      return (
        <div
          key={key}
          // className={`col form-group `}
          className="col-sm-6 col-md-4 col-lg-6 p-0 form-group autocomplete-field"
        >
          <FormControl margin="dense" variant="outlined" fullWidth>
            <TextField
              margin="dense"
              variant="outlined"
              className={` ${classes.labelName}`}
              placeholder={
                values?.fieldsName?.fieldType?.toLowerCase() === 'date' ?
                  'MM/DD/YYYY or Today or T' :
                    `Enter ${field.paramName}`
              }
              onBlur={handleBlur}
              label={'Values'}
              // InputLabelProps={{
              //   shrink: true,
              // }}
              name={field.paramName}
              required
              error={Boolean(fieldSubmitted && errors[field.paramName])}
              value={values[field.paramName] || []}
              onChange={(e) => {
                if (e.target.value) {
                  const newValue = e.target.value.split(',');
                  setFieldValue(field.paramName, newValue);
                } else {
                  setFieldValue(field.paramName, '');
                }
              }}
              fullWidth
            />
          </FormControl>
          <FormHelperText style={{color: 'red'}} variant="outlined">
            {fieldSubmitted && errors[field.paramName] ? errors[field.paramName] : ''}
          </FormHelperText>
        </div>
      );
    case 'fromValues':
    case 'toValues':
      return (
        <div
          key={key}
          // className={`col form-group `}
          className="col-sm-6 col-md-4 col-lg-6 pl-0 form-group autocomplete-field"
        >
          <FormControl margin="dense" variant="outlined" fullWidth>
            <TextField
              margin="dense"
              variant="outlined"
              className={` ${classes.labelName}`}
              placeholder={
                values?.fieldsName?.fieldType?.toLowerCase() === 'date' ?
                  'MM/DD/YYYY or T+/T-' :
                    `Enter ${field.paramLabel}`
              }
              onBlur={handleBlur}
              label={field.paramLabel}
              // InputLabelProps={{
              //   shrink: true,
              // }}
              name={field.paramName}
              required
              error={Boolean(fieldSubmitted && errors[field.paramName])}
              value={values[field.paramName] || []}
              onChange={(e) => {
                if (e.target.value) {
                  setFieldValue(field.paramName, e.target.value);
                } else {
                  setFieldValue(field.paramName, '');
                }
              }}
              fullWidth
            />
          </FormControl>
          <FormHelperText style={{color: 'red'}} variant="outlined">
            {fieldSubmitted && errors[field.paramName] ? errors[field.paramName] : ''}
          </FormHelperText>
        </div>
      );

    case 'disposition':
      return (
        <div
          key={key}
          className={`col-sm-6 col-md-12 col-lg-12 px-0 autocomplete-field form-group ${
              values[field.paramName]?.length > 2 && `autocomplete-checkbox`
            }
            }`}
        >
          <FormControl margin="dense" variant="outlined" fullWidth>
            <GuiAutoComplete
              className={` ${classes.labelName}`}
              multiple
              disableCloseOnSelect
              limitTags={1}
              id="multiple-limit-tags"
              name={field.paramName}
              onBlur={handleBlur}
              // id={field.paramName}
              size="small"
              classes={{
                option: classes.option,
                listbox: classes.listBox,
              }}
              value={values[field.paramName] ? values[field.paramName] : []}
              onChange={(e, value) => {
                setFieldValue(field.paramName, value);
              }}
              disabled={isCurrentFieldDisabled(field.paramName)}
              options={
                getOptions(DISPOSITION_CODE).length > 0 ? getOptions(DISPOSITION_CODE) : []
              }
              autoHighlight
              renderOption={(option, {selected}) => {
                return (
                  <React.Fragment>
                    <>
                      <Checkbox
                        icon={icon}
                        checkedIcon={<CheckBoxIcon fontSize="small" className="selectcheckBox" />}
                        checked={selected}
                        className={classes.checkBox}
                      />
                    </>
                    {`${option?.valueCode} - ${option?.value}`}
                  </React.Fragment>
                );
              }}
              getOptionLabel={(option) => {
                return option && option.value ?
                  option.valueCode === null ?
                    option.value :
                    option.valueCode + ' - ' + option.value :
                  '';
              }}
              renderInput={(params) => (
                <div className="select-field">
                  <GuiTextField
                    {...params}
                    variant="outlined"
                    // margin="dense"
                    // InputLabelProps={{ shrink: true }}
                    label={field?.paramLabel}
                    required
                    error={Boolean(fieldSubmitted && errors[field.paramName])}
                    placeholder={`Select ${
                        field.paramLabel?.includes('Enter') ?
                          'One or More Status' :
                          field.paramLabel
                      }`}
                    className={` autocomplete-multiselect-label`}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'off', // disable autocomplete and autofill
                    }}
                  />
                </div>
              )}
            />
          </FormControl>
          <FormHelperText style={{color: 'red'}} variant="outlined">
            {fieldSubmitted && errors[field.paramName] ? errors[field.paramName] : ''}
          </FormHelperText>
        </div>
      );
    case 'client':
      return (
        <div
          key={key}
          className={`col p-0 form-group  autocomplete-field
            ${values[field.paramName]?.length > 2 && `autocomplete-checkbox`}`}
        >
          <FormControl margin="dense" variant="outlined" fullWidth>
            <GuiAutoComplete
              className={` ${classes.labelName}`}
              multiple
              limitTags={1}
              id="multiple-limit-tags"
              disableCloseOnSelect
              onBlur={handleBlur}
              name={field.paramName}
              // id={field.paramName}
              classes={{
                option: classes.option,
                listbox: classes.listBox,
              }}
              // className="select-tab-autocomplete-dropdown1 "
              size="small"
              getOptionSelected={(option, value) => option?.clientCode === value?.clientCode}
              value={values[field.paramName] ? values[field.paramName] : []}
              onChange={(e, value) => {
                setFieldValue(field.paramName, value);
              }}
              disabled={isCurrentFieldDisabled(field.paramName)}
              options={clientCodeData?.length > 0 ? clientCodeData : []}
              autoHighlight
              renderOption={(option, {selected}) => {
                return (
                  <React.Fragment>
                    <>
                      <Checkbox
                        icon={icon}
                        checkedIcon={<CheckBoxIcon fontSize="small" className="selectcheckBox" />}
                        checked={selected}
                        className={classes.checkBox}
                      />
                    </>
                    {`${option?.clientCode} - ${option?.clientName}`}
                  </React.Fragment>
                );
              }}
              getOptionLabel={(option) => {
                return option && option.clientName ?
                  option.clientCode === null ?
                    option.clientName :
                    option.clientCode + ' - ' + option.clientName :
                  '';
              }}
              renderInput={(params) => (
                <div className="select-field">
                  <GuiTextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    // InputLabelProps={{ shrink: true }}
                    label={field?.paramLabel}
                    required
                    error={Boolean(fieldSubmitted && errors[field.paramName])}
                    placeholder={`Select ${
                        field.paramLabel?.includes('Enter') ?
                          'One or More Client' :
                          field.paramLabel
                      }`}
                    className={`autocomplete-multiselect-label`}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'off', // disable autocomplete and autofill
                    }}
                  />
                </div>
              )}
            />
          </FormControl>
          <FormHelperText style={{color: 'red'}} variant="outlined">
            {fieldSubmitted && errors[field.paramName] ? errors[field.paramName] : ''}
          </FormHelperText>
        </div>
      );
    case 'logicblock':
      return (
        <div key={key} className={`col-sm-6 col-lg-6 form-group `}>
          <TextField
            margin="dense"
            variant="outlined"
            placeholder={`Enter ${field.paramLabel}`}
            className={` ${classes.labelName}`}
            label={field?.paramLabel}
            onBlur={handleBlur}
            disabled
            // InputLabelProps={{
            //   shrink: true,
            // }}
            name={field.paramName}
            value={values[field.paramName] || ''}
            onChange={(e) => {
              setFieldValue(field.paramName, e.target.value);
            }}
            InputProps={{
              endAdornment: (
                <>
                  {values[field?.paramName]?.length > 0 ? (
                    <IconButton
                      onClick={() => {
                        setFieldValue(field?.paramName, '');
                      }}
                      style={{padding: '0px', marginTop: '1rem'}}
                    >
                      <Clear />
                    </IconButton>
                  ) : (
                    <Button
                      variant="contained"
                      className={` ${classes.filterGroupButton}`}
                      style={{
                        padding: '0px',
                        fontSize: '0.7rem',
                        letterSpacing: '1px',
                        fontWeight: 'bold',
                        marginBottom: '3px',
                      }}
                      disabled={isCurrentFieldDisabled(field.paramName)}
                      onClick={() => {
                        dispatch(
                          handleSearchRuleGroupFieldData({
                            status: true,
                            fieldName: field.paramName,
                            setFieldValue: setFieldValue,
                          }),
                        );
                      }}
                      size="small"
                    >
                        Search
                    </Button>
                  )}
                </>
              ),
            }}
            fullWidth
          />
        </div>
      );
    case 'date':
      return field.paramName === 'startDate' ? (
        <div
          key={key}
          className={
            getIsBetween() ?
                `col-sm-6 col-lg-6 pl-0 form-group  new-standard-textfields` :
                `col-sm-6 col-lg-6 form-group  new-standard-textfields` ||
                  `${errors?.lastDate?.length > 30 ? 'new-password-fields' : 'form-group'}`
          }
        >
          <FormControl margin="dense" variant="outlined" fullWidth>
            <TextField
              margin="dense"
              variant="outlined"
              className={` ${classes.labelName}`}
              // placeholder={
              //   values?.fieldsName?.fieldType?.toLowerCase() === "date"
              //     ? "MM/DD/YYYY or T+/T-"
              //     : `Enter ${field.paramLabel}`
              // }
              placeholder="MM/DD/YYYY or Today or T"
              onBlur={handleBlur}
              // label={field.paramLabel}
              label={'From values'}
              // InputLabelProps={{
              //   shrink: true,
              // }}
              name={field.paramName}
              required
              error={
                Boolean(
                  fieldSubmitted && errors[field.paramName] && field.paramName !== 'startDate',
                ) ||
                  Boolean(
                    fieldSubmitted &&
                      errors[field.paramName] &&
                      field.paramName === 'startDate' &&
                      !values[field.paramName],
                  )
              }
              value={values[field.paramName] || []}
              onChange={(e) => {
                if (e.target.value) {
                  setFieldValue(field.paramName, e.target.value);
                } else {
                  setFieldValue(field.paramName, '');
                }
              }}
              fullWidth
            />
          </FormControl>
          {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container>
                <KeyboardDatePicker
                  className={` account-date-picker ${classes.labelName}`}
                  name={field.paramName}
                  format="MM/dd/yyyy"
                  placeholder="MM/DD/YYYY"
                  label={field?.paramLabel}
                  onBlur={handleBlur}
                  fullWidth
                  required
                  maxDate={new Date()}
                  value={values[field.paramName] || null}
                  inputVariant="outlined"
                  margin="dense"
                  helperText=""
                  onChange={(date) => {
                    setFieldValue(field.paramName, date);
                  }}
                  // InputLabelProps={{
                  //   shrink: true,
                  // }}
                  autoOk
                  error={
                    Boolean(
                      fieldSubmitted && errors[field.paramName] && field.paramName !== "startDate"
                    ) ||
                    Boolean(
                      fieldSubmitted && errors[field.paramName] && field.paramName === "startDate"
                    )
                  }
                />
              </Grid>
            </MuiPickersUtilsProvider> */}
          <FormHelperText style={{color: 'red'}} variant="outlined">
            {(errors && fieldSubmitted && field.paramName !== 'startDate') ||
                (errors &&
                  !values[field.paramName] &&
                  field.paramName === 'startDate' &&
                  fieldSubmitted &&
                  errors[field.paramName] &&
                  errors[field.paramName]) ||
                (field.paramName === 'startDate' &&
                  fieldSubmitted &&
                  !values[field.paramName] &&
                  values['action'] === 'Between' &&
                  'From Value is Required')}
          </FormHelperText>
        </div>
      ) : (
        <div
          key={key}
          className={
            getIsBetween() ?
                `${
                    errors[field?.paramName]?.length > 30 ? 'new-password-fields' : 'form-group'
                } col-sm-6 col-lg-6 form-group px-0 hello` :
                `col-sm-6 col-md-4 col-lg-12 px-0  form-group `
          }
        >
          <FormControl margin="dense" variant="outlined" fullWidth>
            <TextField
              margin="dense"
              variant="outlined"
              className={` ${classes.labelName}`}
              // placeholder={
              //   values?.fieldsName?.fieldType?.toLowerCase() === "date"
              //     ? "MM/DD/YYYY or T+/T-"
              //     : `Enter ${field.paramLabel}`
              // }
              placeholder="MM/DD/YYYY or Today or T"
              onBlur={handleBlur}
              // label={field.paramLabel}
              label={field.paramName === 'Date' ? 'Values' : 'To Values'}
              // InputLabelProps={{
              //   shrink: true,
              // }}
              name={field.paramName}
              required
              error={Boolean(fieldSubmitted && errors[field.paramName] && fieldSubmitted)}
              value={values[field.paramName] || []}
              onChange={(e) => {
                if (e.target.value) {
                  setFieldValue(field.paramName, e.target.value);
                } else {
                  setFieldValue(field.paramName, '');
                }
              }}
              fullWidth
            />
          </FormControl>
          {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container>
                <KeyboardDatePicker
                  className={`account-date-picker ${classes.labelName}`}
                  name={field.paramName}
                  format="MM/dd/yyyy"
                  placeholder="MM/DD/YYYY"
                  label={field?.paramLabel}
                  fullWidth
                  onBlur={handleBlur}
                  // minDate={new Date()}
                  required
                  value={values[field.paramName] || null}
                  inputVariant="outlined"
                  margin="dense"
                  helperText=""
                  onChange={(date) => {
                    setFieldValue(field.paramName, date);
                    setSubmitted && setSubmitted(true);
                  }}
                  // InputLabelProps={{
                  //   shrink: true,
                  // }}
                  error={Boolean(fieldSubmitted && errors[field.paramName] && fieldSubmitted)}
                  autoOk
                />
              </Grid>
            </MuiPickersUtilsProvider> */}
          <FormHelperText style={{color: 'red'}} variant="outlined">
            {errors && fieldSubmitted && errors[field.paramName] && errors[field.paramName]}
          </FormHelperText>
        </div>
      );
    case 'collectors' || 'collector':
      return (
        <div
          key={key}
          className={`col-md-12 col-lg-12 px-0 form-group autocomplete-field${
              values[field.paramName]?.length > 2 && `autocomplete-checkbox`
            }`}
          // ${classes.labelName} ${classes.selectdropdown}
        >
          <FormControl margin="dense" variant="outlined" fullWidth>
            <GuiAutoComplete
              className={` ${classes.labelName}`}
              multiple
              disableCloseOnSelect
              limitTags={1}
              id="multiple-limit-tags"
              name={field.paramName}
              onBlur={handleBlur}
              // id={field.paramName}
              classes={{
                option: classes.option,
                listbox: classes.listBox,
              }}
              size="small"
              value={values[field.paramName] ? values[field.paramName] : []}
              onChange={(e, value) => {
                setFieldValue(field.paramName, value);
              }}
              disabled={isCurrentFieldDisabled(field.paramName)}
              options={collectorsData?.length > 0 ? collectorsData : []}
              autoHighlight
              renderOption={(option, {selected}) => {
                return (
                  <React.Fragment>
                    <>
                      <Checkbox
                        icon={icon}
                        checkedIcon={<CheckBoxIcon fontSize="small" className="selectcheckBox" />}
                        checked={selected}
                        className={classes.checkBox}
                      />
                    </>
                    {`${option}`}
                  </React.Fragment>
                );
              }}
              getOptionLabel={(option) => {
                return option;
              }}
              renderInput={(params) => (
                <div className="select-field">
                  <GuiTextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    // InputLabelProps={{ shrink: true }}
                    label={field?.paramLabel}
                    required
                    error={Boolean(fieldSubmitted && errors[field.paramName])}
                    placeholder={`Select ${
                        field.paramLabel?.includes('Enter') ?
                          'One or More Collector' :
                          field.paramLabel
                      }`}
                    className={`autocomplete-multiselect-label`}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'off', // disable autocomplete and autofill
                    }}
                  />
                </div>
              )}
            />
          </FormControl>
          <FormHelperText style={{color: 'red'}} variant="outlined">
            {fieldSubmitted && errors[field.paramName] ? errors[field.paramName] : ''}
          </FormHelperText>
        </div>
      );
    case 'phase':
      return (
        <div
          key={key}
          className={`col p-0 form-group   ${
              values[field.paramName]?.length > 3 && `autocomplete-checkbox`
            }
            }`}
        >
          <FormControl margin="dense" variant="outlined" fullWidth>
            <GuiAutoComplete
              className={` ${classes.labelName}`}
              multiple
              disableCloseOnSelect
              limitTags={1}
              id="multiple-limit-tags"
              onBlur={handleBlur}
              name={field.paramName}
              // id={field.paramName}
              size="small"
              classes={{
                option: classes.option,
                listbox: classes.listBox,
              }}
              value={values[field.paramName] ? values[field.paramName] : []}
              onChange={(e, value) => {
                setFieldValue(field.paramName, value);
                // dirtyRef.current = true;
              }}
              disabled={isCurrentFieldDisabled(field.paramName)}
              options={getOptions(PHASE).length > 0 ? getOptions(PHASE) : []}
              autoHighlight
              renderOption={(option, {selected}) => {
                return (
                  <React.Fragment>
                    <>
                      <Checkbox
                        icon={icon}
                        checkedIcon={<CheckBoxIcon fontSize="small" className="selectcheckBox" />}
                        checked={selected}
                        className={classes.checkBox}
                      />
                    </>
                    {`${option?.valueCode} - ${option?.value}`}
                  </React.Fragment>
                );
              }}
              getOptionLabel={(option) => {
                return option && option.value ?
                  option.valueCode === null ?
                    option.value :
                    option.valueCode + ' - ' + option.value :
                  '';
              }}
              renderInput={(params) => (
                <div className="select-field">
                  <GuiTextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    // InputLabelProps={{ shrink: true }}
                    label={field?.paramLabel}
                    required
                    error={Boolean(fieldSubmitted && errors[field.paramName])}
                    placeholder={`Select ${
                        field.paramLabel?.includes('Enter') ? 'One or More Phase' : field.paramLabel
                      }`}
                    className={`  autocomplete-multiselect-label`}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'off', // disable autocomplete and autofill
                    }}
                  />
                </div>
              )}
            />
          </FormControl>
          <FormHelperText style={{color: 'red'}} variant="outlined">
            {fieldSubmitted && errors[field.paramName] ? errors[field.paramName] : ''}
          </FormHelperText>
        </div>
      );
      // return (
      //   <div
      //     key={key}
      //     className={`col ${classes.labelName} ${classes.selectdropdown} ${values[field.paramName]?.length > 2 && `autocomplete-checkbox`
      //     }`}
      //   >
      //     <FormControl margin="dense" variant="outlined" fullWidth>
      //       <Autocomplete
      //         multiple
      //         name={field.paramName}
      //         id={field.paramName}
      //         size="small"
      //         classes={{
      //           option: classes.option,
      //           listbox: classes.listBox,
      //         }}
      //         value={values[field.paramName]?.length > 0 ? values[field.paramName] : []}
      //         options={[]}
      //         freeSolo
      //         disabled={isCurrentFieldDisabled(field.paramName)}
      //         onChange={(e, value) => {
      //           setFieldValue(field.paramName, value);
      //         }}
      //         renderTags={(value, getTagProps) =>
      //           value.map((option, index) => {
      //             return (
      //               <Chip
      //                 key={index}
      //                 variant="outlined"
      //                 label={option}
      //                 {...getTagProps({ index })}
      //               />
      //             );
      //           })
      //         }
      //         renderInput={(params) => (
      //           <TextField
      //             {...params}
      //             variant="outlined"
      //             margin="dense"
      //             InputLabelProps={{ shrink: true }}
      //             label={field?.paramLabel}
      //             className={` ${classes.labelName} ${classes.selectLabel} ${classes.multiselectlabel} multiselect-label`}
      //             placeholder={`${field.paramLabel}`}
      //             inputProps={{
      //               ...params.inputProps,
      //               autoComplete: "off",
      //             }}
      //           />
      //         )}
      //       />
      //     </FormControl>
      //   </div>
      // );
    }
  };
  return (
    <>
      {accessMethodFields?.length > 0 &&
        accessMethodFields.map((field, key) => {
          return getField(field, key);
        })}
    </>
  );
};

export default GetAccessMethodFields;
